module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/carTypeIcon.svg?f36d56fb";